import { CSSProperties } from 'react';
import cls from 'classnames';

import Link, { NONE } from '@/common/components/Link/Link';
import ProductPlaceholder from '@/media/components/ProductPlaceholder/ProductPlaceholder';

import styles from './MediaPlaceholder.module.css';

interface MediaPlaceholderProps {
  shape?: Nullable<StringOrNumber>;
  href?: Nullable<string>;
  size?: number;
  className?: string;
  style?: CSSProperties;
  navigationTarget?: '_blank' | '_self';
}

export default function MediaPlaceholder(props: MediaPlaceholderProps) {
  const { href = '', size = null, shape, className, style: baseStyle, navigationTarget } = props;

  const style = { ...baseStyle };

  if (size) {
    style.height = `${size}px`;
    style.width = `${size}px`;
  }

  const icon = <ProductPlaceholder shape={shape} color="outline" />;

  return (
    <div className={cls(styles.mediaInListPlaceholder, className)} style={style}>
      <div className={styles.mediaInListPlaceholderContentWrapper}>
        {href ? (
          <Link href={href} appearance={NONE} target={navigationTarget} aria-label="Open product">
            {icon}
          </Link>
        ) : (
          icon
        )}
      </div>
    </div>
  );
}
